import React from 'react';
import styled from 'styled-components';

export const WordlineWrapper = React.memo(styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`);
